import { render, staticRenderFns } from "./VoiceBroadcast.vue?vue&type=template&id=34ca74b9&scoped=true"
import script from "./VoiceBroadcast.vue?vue&type=script&lang=js"
export * from "./VoiceBroadcast.vue?vue&type=script&lang=js"
import style0 from "./VoiceBroadcast.vue?vue&type=style&index=0&id=34ca74b9&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./VoiceBroadcast.vue?vue&type=style&index=1&id=34ca74b9&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca74b9",
  null
  
)

export default component.exports